import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/check-in',
    name: 'CheckIn',
    component: () => import(/* webpackChunkName: 'CheckIn' */ '../views/CheckIn'),
  },
  {
    path: '/equipment',
    name: 'Equipment',
    component: () => import(/* webpackChunkName: 'Equipment' */ '../views/Equipment'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: 'Login' */ '../views/Login'),
  },
  {
    path: '/',
    name: 'MedicalEvaluation',
    component: () => import(/* webpackChunkName: 'medicalEvaluation' */ '../views/MedicalEvaluation.vue'),
  },
  {
    path: '/medical/:id',
    name: 'MedicalEvaluationGeneralData',
    component: () => import(/* webpackChunkName: 'medicalEvaluationGeneralData' */ '../views/MedicalEvaluationGeneralData.vue'),
  },
  {
    path: '/medical/:id/pre',
    name: 'MedicalEvaluationPreBout',
    component: () => import(/* webpackChunkName: 'medicalEvaluationPreBout' */ '../views/MedicalEvaluationPreBout.vue'),
  },
  {
    path: '/medical/:id/post',
    name: 'MedicalEvaluationPostBout',
    component: () => import(/* webpackChunkName: 'medicalEvaluationPostBout' */ '../views/MedicalEvaluationPostBout.vue'),
  },
  {
    path: '/officials',
    name: 'Officials',
    component: () => import(/* webpackChunkName: 'Officials' */ '../views/Officials.vue'),
  },
  {
    path: '/overview',
    name: 'Overview',
    component: () => import(/* webpackChunkName: 'Overview' */ '../views/Overview.vue'),
  },
  {
    path: '/password-forgotten',
    name: 'PasswordForgotten',
    component: () => import(/* webpackChunkName: 'PasswordForgotten' */ '../views/PasswordForgotten.vue'),
  },
  {
    path: '/setup',
    name: 'Setup',
    component: () => import(/* webpackChunkName: 'Setup' */ '../views/Setup.vue'),
  },
  {
    path: '/tournament',
    name: 'Tournament',
    component: () => import(/* webpackChunkName: 'Tournament' */ '../views/Tournament'),
  },
  {
    path: '/tv',
    name: 'TVSchedule',
    component: () => import(/* webpackChunkName: 'TVSchedule' */ '../views/TVSchedule'),
  },
  {
    path: '/weigh-in',
    name: 'WeighIn',
    component: () => import(/* webpackChunkName: 'WeighIn' */ '../views/WeighIn'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
